// extracted by mini-css-extract-plugin
module.exports = {"container":"nav_container__1EoS1","title":"nav_title__1MOlJ","nav":"nav_nav__3cs2S","menu":"nav_menu__1l4EC","list":"nav_list__3j-OD"};